import React from "react";
import { PureComponent } from "react";
import { Spinner } from "react-bootstrap";
import { RouteComponentProps } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthenticationContext } from "services/context/authentication.context";
import PaymentService from "services/payment.service";

interface PaymentProcessorState {
  loading: boolean;
}

const ORDER_TOKEN_PARAM = "order-token";
const SUCCESS_PARAM = "success";
const ERROR_PARAM = "error";

export class PaymentProcessor extends PureComponent<RouteComponentProps, PaymentProcessorState> {

  static contextType = AuthenticationContext;
  constructor(props: RouteComponentProps) {
      super(props);

      this.state = {
          loading: true,
      };
  }

  getTokenFromParams = () => {
    const url = new URL(window.location.href);
    const urlParams = url.searchParams;
    const token = url.searchParams.get(ORDER_TOKEN_PARAM);

    if(token){
      urlParams.delete(ORDER_TOKEN_PARAM);
    }else{
      return;
    }

    window.history.replaceState({}, document.title, url.toString());

    return token;
  };

  redirectToInvoices = (isError : boolean) => {
    window.location.href = `${process.env.REACT_APP_URL}/arved?payment=${isError ? ERROR_PARAM : SUCCESS_PARAM}`
  }

  processPayment = async (token?: string) => {
    if(!token){
      this.redirectToInvoices(true)
      return;
    }

    try{
      const res = await PaymentService.processPayment(token);

      switch(res.data){
        case "CAPTURED" : {
          this.redirectToInvoices(false)
          break;
        }
        case "PENDING" : {
          setTimeout(() => {
            this.processPayment(token);
          }, 5000)
          break;
        }
        default : {
          this.redirectToInvoices(true)
          break;
        }
      }
    }catch(e){
      toast("Makse töötlemine ebaõnnestus", { type: 'error' });

      setTimeout(() => {
        this.redirectToInvoices(true)
      }, 2000)
    }
  }

  componentDidMount(): void {
    const token = this.getTokenFromParams();

    setTimeout(() => {
      this.processPayment(token);
    }, 50);
  }

  render() {
      return (
              <div className="d-flex">
                  {
                      this.state.loading &&
                      <div className="m-auto">
                          <div className="d-flex flex-column justify-content-center align-items-center">
                            <Spinner animation={"grow"}/>
                            <h2 className="mt-2">Töötleme makset...</h2>
                          </div>
                      </div>
                  }
              </div>
      );
  }
}